import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import ProductCard from '../../components/productCard/ProductCard';
import './showcaseBestSellers.scss';

/*-- Imports for redux --*/
import { connect } from 'react-redux';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        webDataCollection: state.webDataCollection
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {};

class ShowcaseBestSellers extends Component {
    constructor(props) {
        super(props)

        this.state = {
            slidesTransform: 0,
            productBlockLength: 10,
            bestSellersProductList: this.props.products
        }
    }

    renderFeaturedProductList() {
        let productArray = [];
        const featuredProductsList = this.props.products
        featuredProductsList.map((product, index) => {
            productArray.push(<div key={index} className="featured-product-slide" style={{ transform: `translateX(${this.state.slidesTransform}%)` }}>
                <Row style={{ margin: 0, paddingBottom: "1.5625rem" }}>
                    <Col xs="12" md={{ span: 10, offset: 1 }}>
                        <ProductCard key={index}
                            itemData={product}
                            showSpecialStyle={this.props.showSpecialStyle}
                        />
                    </Col>
                </Row>
            </div>)
        })

        return productArray;
    };

    goLeft() {
        if (this.state.slidesTransform === 0) {
        } else {
            this.setState({
                slidesTransform: this.state.slidesTransform + 100
            }, () => {
                if (this.state.slidesTransform === 0) {
                    document.getElementById("featured-product-goLeft").style.opacity = 0;
                    document.getElementById("featured-product-goRight").style.opacity = 1;
                } else {
                    document.getElementById("featured-product-goLeft").style.opacity = 1;
                    document.getElementById("featured-product-goRight").style.opacity = 1;
                }
            })
        }
    };

    goRight() {
        if (this.state.slidesTransform === -100 * (this.state.bestSellersProductList.length - 1)) {
        } else {
            this.setState({
                slidesTransform: this.state.slidesTransform - 100
            }, () => {
                if (this.state.slidesTransform === -100 * (this.state.bestSellersProductList.length - 1)) {
                    document.getElementById("featured-product-goRight").style.opacity = 0;
                    document.getElementById("featured-product-goLeft").style.opacity = 1;
                } else {
                    document.getElementById("featured-product-goLeft").style.opacity = 1;
                    document.getElementById("featured-product-goRight").style.opacity = 1;
                }
            })
        }
    };

    render() {
        const featuredProductsList = this.props.products
        return ((this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ?
            <div className="featured-product-slider">
                {
                    this.renderFeaturedProductList()
                }
                <button id="featured-product-goLeft" onClick={this.goLeft.bind(this)}>
                    <i className="fas fa-chevron-left"></i>
                </button>
                <button id="featured-product-goRight" onClick={this.goRight.bind(this)}>
                    <i className="fas fa-chevron-right"></i>
                </button>
            </div >
            :
            <Col xs="12" md={{ span: 10, offset: 1 }}>
                <Row className="m-0 row-cols-2 row-cols-xs-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-5">
                    {featuredProductsList.map(data => {
                        return (<ProductCard
                            key={data.itemID}
                            itemData={data}
                            showSpecialStyle={this.props.showSpecialStyle}
                        />);
                    })}

                </Row>
            </Col>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowcaseBestSellers);